import { useState } from 'react';
import { useStore } from './stores/useStore';
import { useAuthInit } from './hooks/useAuth';
import { Login } from './components/Login';
import { Layout, type Page } from './components/Layout';
import { ProgressPage } from './components/ProgressPage';
import { StartQuizPage } from './components/StartQuizPage';
import { AuthoringPage } from './components/AuthoringPage';
import { CorporatePage } from './components/CorporatePage';
import { Quiz } from './components/Quiz';

type View = 'main' | 'quiz';

function App() {
  useAuthInit();

  const isAuthenticated = useStore((s) => s.isAuthenticated);
  const authLoading = useStore((s) => s.authLoading);
  const [view, setView] = useState<View>('main');
  const [currentPage, setCurrentPage] = useState<Page>('progress');
  const [initialCategory, setInitialCategory] = useState<string | undefined>();
  const [initialSubcategory, setInitialSubcategory] = useState<string | undefined>();

  // Show loading while checking auth
  if (authLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        Loading...
      </div>
    );
  }

  // Show login if not authenticated
  if (!isAuthenticated) {
    return <Login />;
  }

  if (view === 'quiz') {
    return (
      <Quiz
        initialCategory={initialCategory}
        initialSubcategory={initialSubcategory}
        onComplete={() => {
          setView('main');
          setInitialCategory(undefined);
          setInitialSubcategory(undefined);
        }}
      />
    );
  }

  const handleStartQuiz = (category?: string, subcategory?: string) => {
    setInitialCategory(category);
    setInitialSubcategory(subcategory);
    setView('quiz');
  };

  return (
    <Layout currentPage={currentPage} onNavigate={setCurrentPage}>
      {currentPage === 'progress' && <ProgressPage />}
      {currentPage === 'start-quiz' && <StartQuizPage onStartQuiz={handleStartQuiz} />}
      {currentPage === 'authoring' && <AuthoringPage />}
      {currentPage === 'corporate' && <CorporatePage />}
    </Layout>
  );
}

export default App;
